import { type LinkWithTitle } from '@glow/shared/utils/types';

export const masterNavigationLinks: LinkWithTitle[] = [
  {
    title: 'Главная',
    link: '#home',
  },
  {
    title: 'Какие проблемы решаем',
    link: '#solve-problem',
  },
  {
    title: 'Для кого создан',
    link: '#for-whom',
  },
  {
    title: 'Как пользоваться',
    link: '#how',
  },
  {
    title: 'Отличие от других',
    link: '#differences',
  },
  {
    title: 'Отзывы',
    link: '#reviews',
  },
  {
    title: 'Тарифы',
    link: '#tariff',
  },
  {
    title: 'Дополнительные преимущества',
    link: '#additional',
  },
  {
    title: 'FAQ',
    link: '#faq',
  },
];
